import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import SimulatedContentMapAbilityButton from './SimulatedContentMapAbilityButton';
import { FormattedMessage } from 'react-intl';
import messages from './simulatedContentMapAbilitiesMessages';

import './SimulatedContentMapAbilities.scss';

const SimulatedContentMapAbilities = props => (
  <div className="card content-map--abilities">
    <table>
      <thead>
        <tr>
          <th>
            <FormattedMessage {...messages.id} />
          </th>{' '}
          <th>
            <FormattedMessage {...messages.curricularComponent} />
          </th>{' '}
          <th>
            <FormattedMessage {...messages.objectOfKnowledge} />
          </th>{' '}
          <th>
            <FormattedMessage {...messages.officialAbility} />
          </th>{' '}
          <th>
            <FormattedMessage {...messages.indicator} />
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        {props.abilities.map(ability => (
          <tr>
            <td>{ability.abilityId}</td>
            <td>
              {ability.catalogingDiscipline.length > 0
                ? ability.catalogingDiscipline[0].cc_name
                : ''}
            </td>
            <td>{ability.matrixContent || ability.content}</td>
            <td>{ability.abilityName}</td>
            <td>{ability.schoolAbilityName}</td>
            <td>
              <div className="d-flex justify-content-center">
                <SimulatedContentMapAbilityButton
                  isCoordinator={props.isCoordinator}
                  onEdit={() => props.onEdit(ability)}
                  onDelete={() => props.onDelete(ability)}
                  onApprove={() => props.onApprove(ability)}
                  onReprove={() => props.onReprove(ability)}
                  onVisualize={() => props.onVisualize(ability)}
                  status={ability.status}
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

SimulatedContentMapAbilities.propTypes = {};

SimulatedContentMapAbilities.defaultProps = {
  abilities: [],
};
export default SimulatedContentMapAbilities;
